export default "__VITE_ASSET__DE7Znyq8__"